import { ButtonV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

export function PopHeroShopCta(): JSX.Element {
  const t = useTranslations();
  const gen4Enabled = useOuraGen4Enabled();

  const handleShopButtonClick = async () => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'Choose your Oura Ring',
      action: 'go to pdp wizard',
      location: 'POP fixed button',
      path: '/product/rings/oura-gen3/heritage',
    });
  };

  return (
    <ButtonV3
      className={cx('whitespace-nowrap', {
        'fixed bottom-8 z-200 md:bottom-14 md:right-6 lg:right-16 maxmd:left-1/2 maxmd:-translate-x-1/2':
          !gen4Enabled,
      })}
      data-cy="pop_hero_shop_cta"
      href="/product/rings/oura-gen3/heritage"
      onClick={handleShopButtonClick}
    >
      {t('choose_your_oura_ring')}
    </ButtonV3>
  );
}
